export enum DocumentEntityType {
  company,
  employedPerson,
  trainingRecord,
  bugLog,
  trainingCourse,
  observation
}

export enum DocumentEntityTypeString {
  'Company',
  'Operative',
  'Training Record',
  'Bug Log',
  'Training Course',
  'Observation'
}
